/* eslint-disable */
import React from "react";
import about1 from "../../assets/images/about1.jpg";
import about2 from "../../assets/images/about2.jpg";
import about3 from "../../assets/images/about3.jpg";
import about4 from "../../assets/images/about4.jpg";
import mail from "../../assets/images/svg/mail.svg";
import call1 from "../../assets/images/svg/call1.svg";
import { Link } from "react-router-dom";

const About = () => {
  const call = () => {
    return <Link href="tel:9879198344"></Link>;
  };

  return (
    <section className="as_about_wrapper as_padderTop80 as_padderBottom80">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6" style={{ alignItems: "center" }}>
            <div className="as_about_slider">
              <div
                id="carouselExampleCaptions"
                className="carousel slide"
                data-bs-ride="false"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="carousel-indicators">
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="0"
                    className="active"
                    aria-current="true"
                    aria-label="Slide 1"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="1"
                    aria-label="Slide 2"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="2"
                    aria-label="Slide 3"
                  ></button>
                  <button
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide-to="3"
                    aria-label="Slide 4"
                  ></button>
                </div>
                <div className="carousel-inner">
                  <div className="carousel-item active ">
                    <img
                      src={about1}
                      className="d-block w-100 rounded-4"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={about2}
                      className="d-block w-100 rounded-4"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={about3}
                      className="d-block w-100 rounded-4"
                      alt="..."
                    />
                  </div>
                  <div className="carousel-item">
                    <img
                      src={about4}
                      className="d-block w-100 rounded-4"
                      alt="..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-6 knowaboutastro"
            data-aos="zoom-in"
            data-aos-delay="200"
          >
            <h1 className="as_heading as_heading_center   aboutAstro">
              know about Astrology
            </h1>
            <p>
              <strong>Astrology,</strong> type of divination that involves the
              forecasting of earthly and human events through the observation
              and interpretation of the fixed stars, the Sun, the Moon, and the
              planets.
            </p>
            <br />
            <a className="as_contact_expert" href="tel:9879198344">
              <div className="as_info_box">
                <span className="as_icon">
                  <img src={call1} alt="" />
                </span>
                <div className="as_info ">
                  <h5>Call Us</h5>
                  <p className="as_margin0 as_font14">
                    <a>9879198344</a>
                  </p>
                </div>
              </div>
            </a>

            <a
              className="as_contact_expert"
              href="mailto:astromiracle.surat@gmail.com"
            >
              <div className="as_info_box ">
                <span className="as_icon">
                  <img src={mail} alt="" />
                </span>
                <div className="as_info ">
                  <h5>Mail Us</h5>
                  <p className="as_margin0 as_font14">
                    <a href="mailto:astromiracle.surat@gmail.com">
                      astromiracle.surat@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
